import React, { useEffect } from 'react';
import { useAuth } from '../auth/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Callback = () => {
    const { handleCallback } = useAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const code = searchParams.get('code');
        if (code) {
            handleCallback(code)
                .then(() => navigate('/'))
                .catch(err => {
                    console.error("Login failed", err);
                    alert("Login failed: " + err.message);
                    navigate('/login');
                });
        }
    }, [searchParams, handleCallback, navigate]);

    return (
        <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <p>Authenticating...</p>
        </div>
    );
};

export default Callback;
